import { styled } from '@linaria/react';
import { colors, fonts, headingFont, layout, space } from '../../theme/tokens';

export const Section = styled.section`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding-top: ${space[5]};
  padding-bottom: ${space[8]};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-bottom: ${space[9]};
  }
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${space[6]};
  flex-wrap: wrap;
  gap: ${space[3]};
`;

export const Title = styled.h2`
  font-family: ${headingFont};
  font-size: 1.5rem;
  font-weight: ${fonts.weight.medium};
  color: ${colors.fontPrimary};
  margin: 0;
  line-height: 1.3;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: 1.75rem;
  }
`;
